/** The HTML frame's chrome; never the HTML document itself. */
export default {
  themeApp: "App theme",
  themeLight: "Light theme",
  themeDark: "Dark theme",
  themeButton: "Theme: {theme}",
  writeHtml: "Write HTML…",
  htmlSource: "HTML source",
  noHtml: "No HTML content yet",
  saveEditsFailed: "Couldn’t save HTML edits",
  saveThemeFailed: "Couldn’t save HTML theme",
  themeReverted: "The theme change was reverted. Please try again.",
  actionRunNamed: "Run {task} now?",
  actionRunUnnamed: "Run this task now?",
  actionRunDescription: "This button starts the task right away.",
  actionRunConfirm: "Run now",
  actionOpenConnect: "Open {app} in Connections?",
  actionOpenFrameNamed: "Open {title}?",
  actionOpenFrameUnnamed: "Open the linked page?",
  actionOpenTaskNamed: "Open {task}?",
  actionOpenTaskUnnamed: "Open the linked task?",
  actionAnswer: "Answer “{option}”?",
  actionFromPageDescription: "A button inside this page asked for this.",
  actionRateLimited: "Too many button clicks on this page",
  actionRateLimitedDescription: "Wait a moment, then try again.",
  actionFailed: "That button didn’t work",
} as const;
